import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default function (params) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '',
    name: 'GET_MACHINE',
  });

  useEffect(() => {
    if (params && JSON.stringify(params) !== '{}') {
      let url = '/api/energeoverview';
      Object.keys(params).forEach((key, index) => {
        if (index === 0) url += '?';
        else url += '&';
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [isRequestSuccessed, data || {}, exec];
}
